import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserVerifyTy } from "../../../config/types";

const initialState: UserVerifyTy = {
  first_name: "",
  last_name: "",
  email: "",
  user_category: "",
  is_verified: null,
  message: "",
};

export const authState = createSlice({
  name: "authVerify",
  initialState,

  reducers: {
    verify: (_state, action: PayloadAction<UserVerifyTy>) => {
      return action.payload;
    },
  },
});

export const { verify } = authState.actions;

export default authState.reducer;
